import { Component, OnChanges, Input,ViewChild } from '@angular/core';
import { Router ,NavigationEnd} from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged,filter, takeUntil } from 'rxjs/operators';
import { MenuItem } from 'primeng/api';
import { LoginService } from '../services/login.service';
import { GlobalServicesService } from '../services/global-services.service';
import { TalentPoolService } from '../services/talent-pool.service';
import { EventServicesService } from '../services/event-services.service';
import { RoleServicesService } from '../services/role-services.service';
import { AppService } from '../services/app.service';
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    standalone: false
})
export class HeaderComponent implements OnChanges {
  unsub$: Subject<void> = new Subject<void>();
  currentPage: string = '';
  @Input() searchItem: any
  addEventSlider: boolean = false;
  addRoleDialog: boolean = false;
  addCandidateSlider: boolean = false;
  userDetails: any;
  userName: string = '-';
  activeTab: string ='All';
  mouseHover: boolean = false;
  showSearchBar: boolean = false;
  isLoading: boolean = false;
  searchText: string = '';
  order_by: string = 'desc';
  sort_by: string = 'created_at';
  pageSize: number = 10;
  pageNumber: number = 1;
  isCopilotMode: boolean = false;
  isDashboard: boolean = false;
  isAiInterview: boolean = false;
  copilotTitle: string = 'Agent Smith';
  private searchSubject = new Subject<string>();
  userPrivileges: Set<string> = new Set();
  @ViewChild('roleAddComponent') roleAddComponent: any;
  userMeta$ = this.globalService.userMeta$;
  flexBasedUi: boolean = false;
  showSpotlightSearch$: Subject<void> = new Subject<void>();
  constructor(private _router: Router, private loginService: LoginService, private globalService: GlobalServicesService, 
    private talentPoolService: TalentPoolService,private eventServices: EventServicesService,private roleServices: RoleServicesService, private appService: AppService) {
      this._router.events.pipe(
        filter(event => event instanceof NavigationEnd)
      ).subscribe(() => {
        const url = this._router.url;
        this.isCopilotMode = url.startsWith('/copilot');
        this.isDashboard = url.startsWith('/dashboard');
        this.isAiInterview = url.startsWith('/ai-interview');
      });
      this.globalService.privilegeDetailsSubject.subscribe((privileges) => {
        this.userPrivileges = privileges;
      });
    this.searchSubject.pipe(
      debounceTime(500),
    ).subscribe(value => {
      this.globalService.pageNumber = 1;
      const trimmedValue = value.trim();    
      if (trimmedValue.length === 0) {
        this.globalService.searchTerm = '';
        this.fetchFullList();
      } else if (trimmedValue.length > 2) {
        this.searchText = trimmedValue;
        this.globalService.searchTerm = trimmedValue;
        this.searchList();
      }
    });
    this.appService.makeFlexBasedUi.pipe(takeUntil(this.unsub$)).subscribe((res) => {
      this.flexBasedUi = res;
    })
    
  }

  ngOnChanges(): void {
    const url = this._router.url;
    this.isDashboard = url.startsWith('/dashboard');

    this.globalService.userMeta$.subscribe(meta => {
      this.userDetails = meta?.user_profile || {};
      if (this.userDetails.first_name) {
        this.userName = this.userDetails.first_name + ' ' + (this.userDetails.last_name || '');
      } else {
        this.userName = '-';
      }
    });
    this.showSearchBar = !!this.searchItem?.length;
    this.searchFunction();
  }

  signOut = () => {
    this.removeKeys();
    this.loginService.validToken.next({
      status: 403,
      statusMessage: 'loggedOut',
    });
    this._router.navigate(['/logout']);
  }
  removeKeys() {
    for (var attr in localStorage) {
        localStorage.removeItem(attr);
    }
  }

  searchList() {
    let value = this.searchText || '';
    this.globalService.searchTerm = value;
    this.isLoading = true;
  
    const searchTerm = value.trim();
    let validSortBy = this.sort_by;
    if (this.searchItem === 'Candidate') {
      validSortBy = ['uuid', 'email'].includes(this.sort_by) ? this.sort_by : 'uuid';
    }
    if (this.searchItem === 'Events') {
      this.eventServices.getEventsFastApi(
        this.globalService.pageNumber || this.pageNumber,
        this.globalService.pageSize || this.pageSize,
        this.order_by,
        validSortBy,
        searchTerm || undefined
      ).subscribe({
        next: (response: any) => {
          this.isLoading = false;
          if (response.status === 200) {
            this.globalService.searchList.next(response.body);
          }
        },
        error: () => this.isLoading = false
      });
    } else if (this.searchItem === 'Candidate') {
      this.talentPoolService.getAllCandidatesFastApi(
        this.globalService.pageNumber || this.pageNumber,
        this.globalService.pageSize || this.pageSize,
        this.order_by,
        validSortBy,
        searchTerm || undefined
      ).subscribe({
        next: (response: any) => {
          this.isLoading = false;
          if (response.status === 200) {
            this.globalService.searchCandidateList.next(response.body);
          }
        },
        error: () => this.isLoading = false
      });
    }
    else if (this.searchItem === 'Roles') {
      validSortBy = ['id', 'name'].includes(this.sort_by) ? this.sort_by : 'id';
      const searchString = (searchTerm.length >= 3) ? searchTerm : '';
      this.roleServices.getJobRolesFastApi(
        this.globalService.pageNumber || this.pageNumber,
        this.globalService.pageSize || this.pageSize,
        this.order_by,
        validSortBy,
        searchString || undefined,
        undefined // Add filter parameter as undefined for search
      ).subscribe({
        next: (response: any) => {
          this.isLoading = false;
          if (response.status === 200) {
            this.globalService.searchList.next(response.body);
          }
        },
        error: () => this.isLoading = false
      });      
    }
  }

  searchFunction(){
    this.searchText = '';
    this.globalService.searchTerm = '';
  }

  searchTermUpdate() {
    this.searchSubject.next(this.searchText);
  }

  fetchFullList() {
    let sortBy = this.sort_by;
    if (this.searchItem === 'Candidate') {
      sortBy = ['uuid', 'email'].includes(this.sort_by) ? this.sort_by : 'uuid';
    }
  
    if (this.searchItem === 'Events') {
      this.eventServices.getEventsFastApi(
        this.globalService.pageNumber || this.pageNumber,
        this.globalService.pageSize || this.pageSize,
        this.order_by,
        sortBy,
        ''
      ).subscribe({
        next: (response: any) => {
          if (response.status === 200) {
            this.globalService.searchList.next(response.body);
          }
        },
        error: (err) => {
          console.error('Error fetching events', err);
        }
      });
    } else if (this.searchItem === 'Candidate') {
      this.talentPoolService.getAllCandidatesFastApi(
        this.globalService.pageNumber || this.pageNumber,
        this.globalService.pageSize || this.pageSize,
        this.order_by,
        sortBy,
        ''
      ).subscribe({
        next: (response: any) => {
          if (response.status === 200) {
            this.globalService.searchCandidateList.next(response.body);
          }
        },
        error: (err) => {
          console.error('Error fetching candidates', err);
        }
      });
    }
    else if (this.searchItem === 'Roles') {
      sortBy = ['id', 'name'].includes(this.sort_by) ? this.sort_by : 'id';
      this.roleServices.getJobRolesFastApi(
        this.globalService.pageNumber || this.pageNumber,
        this.globalService.pageSize || this.pageSize,
        this.order_by,
        sortBy,
        '',
        undefined
      ).subscribe({
        next: (response: any) => {
          if (response.status === 200) {
            this.globalService.searchList.next(response.body);
          }
        },
        error: (err) => {
          console.error('Error fetching roles', err);
        }
      });
    }
  }
  onCreateEventClick() {
    this.isLoading = false;
    this.addEventSlider = true;
  }

  onCloseEventSlider(event: any) {
    this.addEventSlider = false;
  }
  onCreateRoleClick() {
    this.isLoading = false;
    this.addRoleDialog = true;
  }

  onRoleSidebarShow() {
    setTimeout(() => {
      if (this.roleAddComponent?.initializeData) {
        this.roleAddComponent.initializeData();
      }
    }, 100);
  }

  onCloseRoleDialog(event: any) {
    this.addRoleDialog = false;
  }

  onInviteCandidateClick() {
    this.isLoading = false;
    this.addCandidateSlider = true;
  }
  
  onCloseCandidateSlider(event: any) {
    this.addCandidateSlider = false;
  }
  getUserInitials(userProfile: any): string {    
    if (userProfile?.first_name && userProfile?.last_name) {
      return (userProfile.first_name.charAt(0) + userProfile.last_name.charAt(0)).toUpperCase();
    }
    return 'CD';
  }

  getFullName(userProfile: any): string {
    if (userProfile?.first_name && userProfile?.last_name) {
      return `${userProfile.first_name} ${userProfile.last_name}`;
    }
    return 'User Name';
  }
  viewProfile(): void {
    this._router.navigate(['/settings'], {
      queryParams: {
        menu: "account"
      }
    });
  }
}
